import { render, staticRenderFns } from "./PlatformConsole.vue?vue&type=template&id=6d331946&scoped=true&"
import script from "./PlatformConsole.vue?vue&type=script&lang=js&"
export * from "./PlatformConsole.vue?vue&type=script&lang=js&"
import style0 from "./PlatformConsole.vue?vue&type=style&index=0&id=6d331946&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d331946",
  null
  
)

export default component.exports